// @ts-strict-ignore
import { ExternalLink } from "components/ExternalLink/ExternalLink"
import { Box, Checkbox } from '@node-space/ui-components'
import React from 'react'
import { FiatSendFormData } from "../../form/fiatSendFormSchema"
import { UseFormRegister, UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"

interface AchSameDayCheckboxProps {
  formValues: FiatSendFormData
  register: UseFormRegister<FiatSendFormData>
  setValue: UseFormSetValue<FiatSendFormData>
}
export const AchSameDayCheckbox = ({ formValues, register, setValue }: AchSameDayCheckboxProps) => {
  const { t } = useTranslation()

  return (
    <Checkbox
      {...register('achSameDay')}
      id="ach-sameday-checkbox"
      testId="ach-sameday-checkbox"
      checked={formValues?.achSameDay}
      onCheckedChange={() => setValue('achSameDay', !formValues?.achSameDay)}
      label={t('wallets.fiatSend.makeAchSameDayPayment')}
    >
      <Box flex>
      <p className="text-body-regular-small text-foreground-faint pr-1">
          {t('wallets.fiatSend.subjectToCutOffTimes')}
      </p>
      <p className="text-body-regular-small text-foreground-secondary pr-1">
          <ExternalLink href={process.env.VA_CUT_OFF_TIMES_LEARN_MORE}>
          {t('learnMore')}
          </ExternalLink>
      </p>
      </Box>
    </Checkbox>
  )
}